var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDollarCoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "-0.957 -1.191 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.444 6.479a1.607 1.607 0 0 0-1.51-1.054h-1.24c-.79 0-1.43.631-1.43 1.411 0 .663.468 1.237 1.124 1.38l1.888.407c.735.159 1.26.802 1.26 1.545 0 .874-.718 1.582-1.602 1.582h-1.068c-.698 0-1.291-.44-1.51-1.054M13.4 5.425V3.843M13.4 13.33V11.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.714 8.587c0 .996.199 1.983.585 2.903s.952 1.757 1.666 2.462a7.7 7.7 0 0 0 2.494 1.644 7.77 7.77 0 0 0 5.882 0 7.7 7.7 0 0 0 2.493-1.644A7.6 7.6 0 0 0 20.5 11.49c.387-.92.586-1.907.586-2.903 0-2.012-.81-3.942-2.251-5.365A7.74 7.74 0 0 0 13.4 1c-2.039 0-3.994.8-5.435 2.222a7.54 7.54 0 0 0-2.251 5.365M1.925 9.417A7.5 7.5 0 0 0 1 13.03c0 4.19 3.44 7.588 7.685 7.588a7.7 7.7 0 0 0 3.355-.76"
}))));
export default SvgDollarCoin;